import LiveAdjustingCropGridValue from "./LiveAdjustingCropGridValue";
import CropGridValue from './CropGridValue';
import React, { useState } from 'react';

import EndpointCropAdjustmentLayer from './EndpointCropAdjustmentLayer';
import VerticalCropAdjustmentLayer from './VerticalCropAdjustmentLayer';






export default function AdjustableCropGridValue(props){


  const [ liveSide, _setLiveSide ] = useState();

  const setLiveSide = (x) => {
    _setLiveSide(x);
  }


  
  let cropComp;
  if( liveSide ){
    cropComp = (
      <>
      <LiveAdjustingCropGridValue 
        {...props}
        liveSide={liveSide}
        setLiveSide={setLiveSide}
      />
        
      </>
    )
  }else{
    cropComp = <CropGridValue
      {...props}
      liveSide={liveSide}
      setLive={setLiveSide}
      />
  }


  let adjustmentLayers = /*!liveSide &&*/ props.editable && props.tableOutlineShowing && [
    <EndpointCropAdjustmentLayer {...{
      liveSide,
        ...props,
        height:15,
        setLiveSide,
      }}/>,
    !liveSide && (<VerticalCropAdjustmentLayer {...{
        ...props,
        setLiveSide
      }}/>)
  ]


  return (
    <>
      {cropComp}
      {adjustmentLayers}
    </>
  )




}
